import LOOKUP from "../../../constants/lookup";

//make sure change the currentAIVideoVersion to differet version everytime you add more videos
export const currentAIVideoVersion = "1.0.2";
// make sure you define the type for all the video list by Either All, First Nation or Licensed Retail to toggle on and off for each of the application type.

export const aiVideoList = [
  {
    pageName: "Business Insights",
    path: "/",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Business Insights Page", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/B3Nz0raIPPk" },
      { type: LOOKUP.AiVideoType.LicensedRetail, title: "Licensed Retail - Manager Training", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/3a-djKsUZDo" },
      { type: LOOKUP.AiVideoType.LicensedRetail, title: "Licensed Retail - Budtender Training", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/wi39i2qFCuM" },
      { type: LOOKUP.AiVideoType.FirstNation, title: "First Nation - Manager Training", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/Z5ArMfgZ734" },
      { type: LOOKUP.AiVideoType.FirstNation, title: "First Nation - Budtender Training", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/APo-JD5CPoQ" },
    ]
  },
  {
    pageName: "POS Sales",
    path: "/pos",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Refund an Order", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/xLF8j8TtC4A" },
      { type: LOOKUP.AiVideoType.All, title: "POS not Configured", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/QrtLjA9vKI0" },
      { type: LOOKUP.AiVideoType.All, title: "Apply Discounts", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/IJC9or31L20" },
      { type: LOOKUP.AiVideoType.All, title: "Create Discounts", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/Mm5r9eWg5-0" },
      { type: LOOKUP.AiVideoType.All, title: "Search & Add Members", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/dcbq3IOTFfI" },
      { type: LOOKUP.AiVideoType.All, title: "Making a Retail Sale", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/OWvJRey_byY" },  // outdated UI
      { type: LOOKUP.AiVideoType.All, title: "Create a Generic Accessory", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/jxntAvMK2OA" },
    ]
  },
  {
    pageName: "POS Sales with an Order",
    path: "/pos/hasNumber",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Refund an Order", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/xLF8j8TtC4A" },
      { type: LOOKUP.AiVideoType.All, title: "POS not Configured", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/QrtLjA9vKI0" },
      { type: LOOKUP.AiVideoType.All, title: "Apply Discounts", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/IJC9or31L20" },
      { type: LOOKUP.AiVideoType.All, title: "Create Discounts", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/Mm5r9eWg5-0" },
      { type: LOOKUP.AiVideoType.All, title: "Search & Add Members", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/dcbq3IOTFfI" },
      { type: LOOKUP.AiVideoType.All, title: "Making a Retail Sale", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/OWvJRey_byY" },  // outdated UI
    ]
  },
  {
    pageName: "Products",
    path: "/product",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Products Page", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/6XbLN6Zhk1A" },
      { type: LOOKUP.AiVideoType.All, title: "Create a Product", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/_qRog216eRk" },
      { type: LOOKUP.AiVideoType.All, title: "Create a Generic Accessory", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/jxntAvMK2OA" },
    ]
  },
  {
    pageName: "Product Edit",
    path: "/product/hasNumber",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "How to Edit a Product", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Product Add",
    path: "/product/add",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Create New Product", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/_qRog216eRk" }
    ]
  },
  {
    pageName: "Product Edit",
    path: "/product/edit",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "How to Edit a Product", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Product Edit",
    path: "/product/edit/hasNumber",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Product Edit Has a Number", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Categories",
    path: "/product/category",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Categories Page", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/iiFNRl6iaYw" }
    ]
  },
  {
    pageName: "Categories Add",
    path: "/product/category/add",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Categories Page", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/iiFNRl6iaYw" }
    ]
  },
  {
    pageName: "Purchase Orders",
    path: "/purchaseorder",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Create a Purchase Order", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/1ejJnK2EvC4" }
    ]
  },
  {
    pageName: "Purchase Orders Edit",
    path: "/purchaseOrder/edit/hasNumber",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Create a Purchase Order", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/1ejJnK2EvC4" }
    ]
  },
  {
    pageName: "Purchase Orders Add",
    path: "/purchaseorder/add",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Create a Purchase Order", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/1ejJnK2EvC4" }
    ]
  },
  {
    pageName: "Warehouse",
    path: "/transferproduct",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Warehouse Page", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/yb4JTJNfFDM" }
    ]
  },
  {
    pageName: "Bulk Transfer",
    path: "/bulktransferproduct",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Bulk Transfer Page", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/P5I1yfcYAFU" }
    ]
  },
  {
    pageName: "Bulk Transfer Edit",
    path: "/bulktransferproduct/edit/hasNumber",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "bulktransferproduct Edit Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Bulk Transfer Add",
    path: "/bulktransferproduct/add",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Bulk Transfer Add video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Product Hub",
    path: "/producthub",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Product Hub Page", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/urSLAMDmH0I" },
      { type: LOOKUP.AiVideoType.All, title: "How to Adjust Inventory", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/IPVSDFimcE4" }
    ]
  },
  {
    pageName: "Inventory Audit",
    path: "/inventoryAudit",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Inventory Audit Page", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/QczIbtVcby4" }
    ]
  },
  {
    pageName: "Inventory Audit Edit",
    path: "/inventoryaudit/hasNumber",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Inventory Audit Page", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/QczIbtVcby4" }
    ]
  },
  {
    pageName: "Multi Store Inventory Management",
    path: "/multistoremanagement",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Multi Store Management video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Vendor List",
    path: "/vendor",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Vendor List Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Vendor Edit",
    path: "/vendor/edit/hasNumber",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Vendor Edit video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Vendor Add",
    path: "/vendor/add",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "How to Add a New Vendor", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/ePpAeVEiAu4" }
    ]
  },
  {
    pageName: "Accessory Vendor Catalog",
    path: "/vendorcatalog",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Accessory Vendor Catalog", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/0I2GwgwFLS4" }
    ]
  },
  {
    pageName: "Member",
    path: "/member",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Managing Members", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/YV8ovULv00k" }
    ]
  },
  {
    pageName: "Member Add",
    path: "/member/add",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Managing Members", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/YV8ovULv00k" }
    ]
  },
  {
    pageName: "Member Edit",
    path: "/member/edit/hasNumber",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Managing Members", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/YV8ovULv00k" }
    ]
  },
  {
    pageName: "Employee",
    path: "/employee",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Managing Employees", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/zLkPg6MirTA" }
    ]
  },
  {
    pageName: "Employee",
    path: "/employee/add",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Managing Employees", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/zLkPg6MirTA" }
    ]
  },
  {
    pageName: "Employee Information",
    path: "/employee/hasNumber",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Managing Employees", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/zLkPg6MirTA" }
    ]
  },
  {
    pageName: "Employee Edit",
    path: "/employee/edit/hasNumber",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Managing Employees", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/zLkPg6MirTA" }
    ]
  },
  {
    pageName: "Doctor",
    path: "/doctor",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Doctor video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "User Role",
    path: "/userrole",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "User Role Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "User Role Edit",
    path: "/userrole/edit/hasNumber",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "User Role Edit Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Cash Register",
    path: "/admin/cashregister",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Managing Cash Registers", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/MW4T8Ij8wdE" }
    ]
  },
  {
    pageName: "Cash Register Edit",
    path: "/admin/cashregister/edit/hasNumber",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Cash Register Edit Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Shifts",
    path: "/admin/shift/list",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Managing Employee Shifts", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/pkCRlkViHCM" }
    ]
  },
  {
    pageName: "Shifts Edit",
    path: "/admin/shift/edit/hasNumber",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Managing Employee Shifts", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/pkCRlkViHCM" }
    ]
  },
  {
    pageName: "Shifts Add",
    path: "/admin/shift/admin/shift/add",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Managing Employee Shifts", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/pkCRlkViHCM" }
    ]
  },
  {
    pageName: "Schedules",
    path: "/admin/schedule",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Managing Employee Schedules", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/QAUqu4bdo0I" }
    ]
  },
  {
    pageName: "Orders",
    path: "/admin/orders",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Managing POS Orders", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/keIptbuwyJE" }
    ]
  },
  {
    pageName: "Orders Detail",
    path: "/admin/orders/detail/hasNumber",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Orders Detail Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Marketing",
    path: "/admin/marketing",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "How to Manage Marketing Tools", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/bGp7olZmFO8" }
    ]
  },
  {
    pageName: "Settings",
    path: "/admin/setting",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Managing System Settings", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/pWJTBDHfkE0" }
    ]
  },
  {
    pageName: "Reports",
    path: "/report",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Reports video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Measurement Setting",
    path: "/manage/measurement",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Measurement & Price Matrix Settings", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/GUmTDQEEN9E" }
    ]
  },
  {
    pageName: "Measurement Setting Edit",
    path: "/manage/measurement/edit/hasNumber",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Measurement & Price Matrix Settings", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/GUmTDQEEN9E" }
    ]
  },
  {
    pageName: "Measurement Setting Add",
    path: "/manage/measurement/add",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Measurement & Price Matrix Settings", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/GUmTDQEEN9E" }
    ]
  },
  {
    pageName: "Price Matrix Setting",
    path: "/pricematrix",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Measurement & Price Matrix Settings", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/GUmTDQEEN9E" }
    ]
  },
  {
    pageName: "Price Matrix Add",
    path: "/priceMatrix/add",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Measurement & Price Matrix Settings", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/GUmTDQEEN9E" }
    ]
  },
  {
    pageName: "Price Matrix Edit",
    path: "/priceMatrix/edit/hasNumber",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Measurement & Price Matrix Settings", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/GUmTDQEEN9E" }
    ]
  },
  {
    pageName: "Tax Setting",
    path: "/manage/taxrate",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Tax Setting video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Tax Edit",
    path: "/manage/taxrate/edit/hasNumber",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Tax Edit video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Tax Add",
    path: "/manage/taxrate/add",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Tax Add video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Campaign",
    path: "/manage/campaign",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Managing Campaigns", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/Khj2hF2KwYI" }
    ]
  },
  {
    pageName: "Campaign",
    path: "/manage/campaign/edit/hasNumber",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Managing Campaigns", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/Khj2hF2KwYI" }
    ]
  },
  {
    pageName: "Campaign",
    path: "/manage/campaign/add",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Managing Campaigns", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/Khj2hF2KwYI" }
    ]
  },
  {
    pageName: "Combo",
    path: "/manage/combo",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Managing Combos", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/bavwdgqLG4A" }
    ]
  },
  {
    pageName: "Combo Edit",
    path: "/manage/combo/edit/hasNumber",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Managing Combos", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/bavwdgqLG4A" }
    ]
  },
  {
    pageName: "Combo Add",
    path: "/manage/combo/add",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Managing Combos", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/bavwdgqLG4A" }
    ]
  },
  {
    pageName: "Customized Discount",
    path: "/manage/discount",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Managing Customized Discounts", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/SFvFykgP-FI" }
    ]
  },
  {
    pageName: "Customized Discount Edit",
    path: "/manage/discount/edit/hasNumber",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Managing Customized Discounts", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/SFvFykgP-FI" }
    ]
  },
  {
    pageName: "Customized Discount Add",
    path: "/manage/discount/add",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Managing Customized Discounts", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/SFvFykgP-FI" }
    ]
  },
  {
    pageName: "Device",
    path: "/manage/device",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Managing Devices", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/S-jFytoepdI" }
    ]
  },
  {
    pageName: "Device Add",
    path: "/manage/device/add",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "How to Add a Device", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }  // the managing devices doesn't cover how to add devices
    ]
  },
  {
    pageName: "Device Edit",
    path: "/manage/device/edit/hasNumber",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Managing Devices", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/S-jFytoepdI" }
    ]
  },
  {
    pageName: "Payment",
    path: "/manage/payment",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Payment video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Payment Edit",
    path: "/manage/payment/edit/hasNumber",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Payment edit video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Payment Add",
    path: "/manage/payment/add",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Payment edit video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Video Support",
    path: "/video-support",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Video Support video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Ecommerce-Online-Order",
    path: "/ecommerce/online-orders",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Managing Online Orders", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/_yX-ZzgYsgs" }
    ]
  },
  {
    pageName: "Ecommerce-Online-Order",
    path: "/ecommerce/online-orders/details/hasNumber",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Online Orders Page", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/6BYKiM-wgsE" }
    ]
  },
  {
    pageName: "Ecommerce-Online-Order",
    path: "/ecommerce/online-orders/storerules/edit/hasNumber",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Online Orders Page", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/6BYKiM-wgsE" }
    ]
  },
  {
    pageName: "Store Rules List",
    path: "/ecommerce/storerules",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Managing Web Menu Store Rules", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/J3Er3stZV7o" }
    ]
  },
  {
    pageName: "Menu (Categories) List",
    path: "/ecommerce/menu",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Managing Web Menu Categories", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/hovTmYgDzEc" }
    ]
  },
  {
    pageName: "Carousel List",
    path: "/ecommerce/carousel",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Add a New Carousel", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/ktyPIzMNrD8" }
    ]
  },
  {
    pageName: "UI Setting",
    path: "/ecommerce/uisetting",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Managing Web Menu UI Settings", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/nWYQgWMSgi0" }
    ]
  },

  // =====  REPORTS BEGIN  ====== //

  {
    pageName: "Annual Sales Summary",
    path: "/report/annual-sales",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Annual Sales Summary Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Budtender Average Sales",
    path: "/report/budtender-average-sales",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Budtender Average Sales Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Daily Cash Flow Summary",
    path: "/report/daily-cash-summary",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Daily Cash Flow Summary Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Inventory Planner & Revenue Report",
    path: "/report/revenue-report",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Inventory Planner & Revenue Report Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Transaction Count Summary",
    path: "/report/transaction-summary",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Transaction Count Summary Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Credit Payments",
    path: "/report/credit-payments",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Credit Payments Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Daily Sales By Type",
    path: "/report/sales-by-type",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Daily Sales By Type Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Profit Report",
    path: "/report/profit-report",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Profit Report Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Manual Inventory Change",
    path: "/report/manual-inventory-change",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Manual Inventory Change Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Product Velocity",
    path: "/report/inventory-level",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Product Velocity Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "End Of Day Report",
    path: "/report/endofday",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "End Of Day Report Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Sales By Category",
    path: "/report/category-sales",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Sales By Category Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Product Sales",
    path: "/report/product-sales",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Product Sales Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Inventory Trend By Sale (Re-Order Report)",
    path: "/report/reorder-report",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Inventory Trend By Sale (Re-Order Report) Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Tax Summary",
    path: "/report/tax-summary",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Tax Summary Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Sigma Report",
    path: "/report/sigma-report",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Sigma Report Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Hourly Sales",
    path: "/report/hourly-sales",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Hourly Sales Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Purchase Order Report",
    path: "/report/purchaseorder-report",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Purchase Order Report Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Order Details",
    path: "/report/transaction-details",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Order Details Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Destroyed Product Report",
    path: "/report/destroyed-product",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Destroyed Product Report Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Monthly Sales Summary",
    path: "/report/sales-summary",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Monthly Sales Summary Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Member Sales",
    path: "/report/customer-sales",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Member Sales Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Shift by Day",
    path: "/report/shift-day",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Shift by Day Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Manual Inventory Change In Cannabis Products",
    path: "/report/discrepancy-report",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Manual Inventory Change In Cannabis Products Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Shift by Employee",
    path: "/report/shift-employee",
    empNumber: { label: "Employee Number", name: "Employee Number" },
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Shift by Employee Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Monthly Product Sales",
    path: "/report/monthly-sales",
    year: { label: "Year", name: "Year" },
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Monthly Product Sales Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Daily Inventory SnapShot",
    path: "/report/inventorySnapShot",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Daily Inventory SnapShot Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Employee Total Hours",
    path: "/report/employee-hours",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Employee Total Hours Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Timesheet",
    path: "/report/timesheet",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Timesheet Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "FederalReport",
    year: { label: "Year", name: "Year" },
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "FederalReport Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  // ... previous reports
  {
    pageName: "Inventory Transfer",
    path: "/report/warehouse-transfer",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Inventory Transfer Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Discount Report",
    path: "/report/discount-report",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Discount Report Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Sales Report Day over Day",
    path: "/report/daily-sales-report",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Sales Report Day over Day Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Sales Report Month over Month",
    path: "/report/monthly-sales-report",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Sales Report Month over Month Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Sales Report Year over Year",
    path: "/report/yearly-sales-report",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Sales Report Year over Year Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Sell Through Report",
    path: "/report/sell-through-report",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Sell Through Report Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Profit Report Day over Day",
    path: "/report/daily-profit-report",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Profit Report Day over Day Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Profit Report Month over Month",
    path: "/report/monthly-profit-report",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Profit Report Month over Month Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Profit Report Year over Year",
    path: "/report/yearly-profit-report",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Profit Report Year over Year Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "GMROI",
    path: "/report/gmroi-report",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "GMROI Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Shopping Trend",
    path: "/report/shopping-trend",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Shopping Trend Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Aggregate Sales Report",
    path: "/report/aggregate-sales",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Aggregate Sales Report video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Inventory & Sales",
    path: "/report/aggregate-inventory",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Inventory & Sales video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Budget Planner",
    path: "/report/budget-planner",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Budget Planner video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Aggregate Branches",
    path: "/report/aggregate-branches",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Aggregate Branches video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Combined Sales Report",
    path: "/report/combined-sales",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Combined Sales Report video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Aggregate Inventory Level Report",
    path: "/report/aggregate-inventoryLevel",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Aggregate Inventory Level Report video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Sales By Brand",
    path: "/report/brand-sales",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Sales By Brand video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Online Versus In-Store Sales",
    path: "/report/onlineinstore-sales",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Online Versus In-Store Sales vide", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Order List By Online/Instore",
    path: "/report/orderlist-sales",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Order List By Online/Instore video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Inventory Age",
    path: "/report/inventoryage",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Inventory Age video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Member Demographics",
    path: "/report/members-demographics",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Member Demographics video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Product Ranking Report",
    path: "/report/product-ranking",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Product Ranking Report video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Re-stock By Caps",
    path: "/report/restockbycaps",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Re-stock By Caps Report Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Product By Category",
    path: "/report/category-product",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Product By Category Report Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "IRCC Report",
    path: "/report/ircc",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "IRCC Report Report Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Hourly Sales By Date Range",
    path: "/report/hourly-sales-date-range",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Hourly Sales By Date Range Report Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Hourly Sales Averaged",
    path: "/report/hourly-sales-averaged",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Hourly Sales Averaged Report Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Product Price Change",
    path: "/report/product-price-change-report",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Product Price Change Report Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Purchase Order Receiver Report",
    path: "/report/purchase-order-receiver",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Purchase Order Receiver Report Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Delivery",
    path: "/report/delivery-report",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Delivery Report Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Gift Card History",
    path: "/report/gift-card-history",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Gift Card History Report video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  },
  {
    pageName: "Monthly Inventory",
    path: "/report/MonthlyInventory",
    aiVideos: [
      { type: LOOKUP.AiVideoType.All, title: "Monthly Inventory Report Video", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/NhMGtk4Yevs" }
    ]
  }
];
